import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const TextContainer = styled.div<{ showTextBox?: boolean }>`
  ${({ theme, showTextBox }) => css`
    display: ${showTextBox === undefined
      ? 'flex'
      : showTextBox
      ? 'flex'
      : 'none'};
    position: relative;
    z-index: 5;
    align-items: flex-end;
    justify-content: space-between;
    width: 100%;
    padding-bottom: 12px;
  `}
`;

export const SubMenuButtonBox = styled.div`
  display: flex;
  position: absolute;
  bottom: 11px;
  align-items: center;
  justify-content: center;
`;

export const SubMenuButton = styled.button`
  width: 44px;
  height: 44px;
  padding: 6px 6px 6px 10px;
  cursor: pointer;
`;

export const TextWrapper = styled.div`
  ${({ theme }) => css`
    position: relative;
    width: 100%;
    padding: 8px 72px 8px 12px;
    border-radius: 20px;
    background: ${theme.backgroundColor.bg_light_2_alpha};
    box-shadow: 0px 0px 16px 0px rgba(255, 255, 255, 0.25) inset;
  `}
`;

export const InputBox = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
`;

export const ButtonWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: absolute;
    right: 6px;
    bottom: 6px;
    align-items: center;
    justify-content: center;
    color: ${theme.content.hierarchy1};
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    gap: 4px;
  `}
`;

export const ButtonBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SendButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    overflow: hidden;
    transition: background 0.3s ease-in-out;
    border-radius: 50%;
    background: ${theme.themeColor.main_1};

    &:disabled {
      background: ${theme.backgroundColor.bg_light_4};
    }

    img {
      width: 100%;
      height: 100%;
    }
  `}
`;

export const DirectionButton = styled.button`
  width: 28px;
  height: 28px;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const TextBox = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
`;

export const Text = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 25px;
    min-height: 25px;
    max-height: 75px;
    overflow: auto;
    border: none;
    outline: none;
    color: ${theme.content.content_dark_1};
    line-height: 25px;

    & > span {
      display: inline-block;
      color: ${theme.themeColor.main_dark};
      font-weight: 600;
    }
  `}
`;

export const MemberList = styled.ul<{ bottom: number }>`
  ${({ theme, bottom }) => css`
    -webkit-overflow-scrolling: touch;
    position: absolute;
    z-index: 1000;
    bottom: ${bottom >= 100 ? '100px' : `${bottom + 25}px`};
    left: 0;
    width: 100%;
    max-height: 154px;
    overflow-y: auto;
    border: 1px solid ${theme.stroke.stroke_1};
    border-radius: 8px;
    background: ${theme.backgroundColor.bg_dark_1};
  `}
`;

export const MemberBox = styled.li<{ selected: boolean }>`
  ${({ theme, selected }) => css`
    display: flex;
    align-items: center;
    height: 44px;
    padding: 4px;
    padding: 8px;
    background: ${selected
      ? theme.backgroundColor.bg_light_5_alpha
      : 'transparent'};
    cursor: pointer;
    gap: 8px;
  `}
`;

export const MemberIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MemberName = styled.strong`
  ${({ theme }) => css`
    display: block;
    color: ${theme.content.content_light_1};
    ${theme.fontStyle.text.body14_medium};
    white-space: nowrap;
  `}
`;

export const MemberId = styled.span`
  ${({ theme }) => css`
    display: block;
    overflow: hidden;
    color: ${theme.content.content_light_5};
    ${theme.fontStyle.text.body14_regular};
    text-overflow: ellipsis;
    white-space: nowrap;
  `}
`;
